import { Emplooyee } from './../../../common/entities/employee';
import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { EmployeeService } from '../../../employee/services/employee.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    NineCharacterValidation,
    PostalCodeValidation,
    noWhiteSpacesValidator,
    AdultValidation,
} from 'app/modules/common/validation/common-validation';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { DireccionService } from '../../services/direccion.service';
import {
    filter,
    tap,
    debounceTime,
    distinctUntilChanged,
    switchMap,
    map,
} from 'rxjs/operators';
import { SharedService } from 'app/modules/common/services/shared-service';
import { CompanyTreeViewService } from 'app/modules/fuse/components/tree-view/service/company-tree-view.service';
import { EmpresaTreeViewService } from '../../../employee/services/empresa-treeView.service';

@Component({
    selector: 'app-trabajador-edit',
    templateUrl: './trabajador-edit.component.html',
    styleUrls: ['./trabajador-edit.component.scss'],
    providers: [{ provide: MAT_DATE_LOCALE, useValue: 'es-ES' }],
    standalone: false
})
export class TrabajadorEditComponent implements OnInit, OnDestroy {
    EmployeeFormGroup: UntypedFormGroup;
    HeaderName: string;
    isSaving = false;
    SelectedTrabajadorId: number;
    EmployeeDetailSubcription: Subscription;
    public ProvinceList: Array<{ value: string; viewValue: string }>;
    Direction1Validating: boolean;
    Direction1Validated: boolean;
    Direction2Validating: boolean;
    Direction2Validated: boolean;
    empresaDetails: any;
    empresaId: number;
    isPuestoUrgente: boolean = false;
    isTeleCancelado: boolean = false;
    constructor(
        public dialogRef: MatDialogRef<TrabajadorEditComponent>,
        public snackBar: MatSnackBar,
        public employeeService: EmployeeService,
        public _fb: UntypedFormBuilder,
        public directionService: DireccionService,
        public companyTreeService: CompanyTreeViewService,
        private empresaTreeViewService: EmpresaTreeViewService,
        private changeDetectionRef: ChangeDetectorRef,
        private sharedService: SharedService
    ) {}

    ngOnInit(): void {
        this.InitEmployeeForm();
        this.GetHardCodedList();
        this.EmployeeDetailSubcription = this.employeeService
            .subcribeEditEmployee()
            .subscribe((result) => {
                const editEmployeeData = Object.assign({}, result);
                this.empresaId = result.empresaId;
                if (editEmployeeData) {
                    this.HeaderName = `${editEmployeeData.apellidos}, ${editEmployeeData.nombre}`;
                    this.SelectedTrabajadorId = editEmployeeData.trabajadorId;

                    this.EmployeeFormGroup.get('BirthDate').patchValue(
                        editEmployeeData.fnacimiento !== null
                            ? DateHelper.getMomentDate(
                                  editEmployeeData.fnacimiento
                              )
                            : null
                    );
                    this.EmployeeFormGroup.get('Position').patchValue(
                        editEmployeeData.puesto
                    );
                    this.EmployeeFormGroup.get('Telephone1').patchValue(
                        editEmployeeData.telefono1
                    );
                    this.EmployeeFormGroup.get('Telephone2').patchValue(
                        editEmployeeData.telefono2
                    );
                    this.EmployeeFormGroup.get('Movil').patchValue(
                        editEmployeeData.movil
                    );
                    this.EmployeeFormGroup.get('Telephone4').patchValue(
                        editEmployeeData.telefono4
                    );
                    this.EmployeeFormGroup.get('Direction1').patchValue(
                        editEmployeeData.direccion
                    );
                    this.EmployeeFormGroup.get('Province1').patchValue(
                        editEmployeeData.provincia
                    );
                    this.EmployeeFormGroup.get('City1').patchValue(
                        editEmployeeData.poblacion
                    );
                    this.EmployeeFormGroup.get('PostalCode1').patchValue(
                        editEmployeeData.cp
                    );
                    this.EmployeeFormGroup.get('Direction2').patchValue(
                        editEmployeeData.direccion2
                    );
                    this.EmployeeFormGroup.get('Province2').patchValue(
                        editEmployeeData.provincia2
                    );
                    this.EmployeeFormGroup.get('City2').patchValue(
                        editEmployeeData.poblacion2
                    );
                    this.EmployeeFormGroup.get('PostalCode2').patchValue(
                        editEmployeeData.cp2
                    );
                    this.EmployeeFormGroup.get('ObsDireccion').patchValue(
                        editEmployeeData.obsDireccion
                    );
                    this.EmployeeFormGroup.get('Observation').patchValue(
                        editEmployeeData.obs
                    );
                    this.EmployeeFormGroup.get('Nif').patchValue(
                        editEmployeeData.nif
                    );
                    this.EmployeeFormGroup.get('Sexo').patchValue(
                        editEmployeeData.sexo
                    );
                    this.EmployeeFormGroup.get('Apellidos').patchValue(
                        editEmployeeData.apellidos
                    );
                    this.EmployeeFormGroup.get('Nombre').patchValue(
                        editEmployeeData.nombre
                    );
                    this.EmployeeFormGroup.get('TipoConsentimiento').patchValue(
                        editEmployeeData.tipoConsentimiento
                    );
                    this.EmployeeFormGroup.get('Consentimiento').patchValue(
                        editEmployeeData.consentimiento
                    );
                    this.EmployeeFormGroup.get('RefTrabajador').patchValue(
                        editEmployeeData.refTrabajador
                    );
                    this.EmployeeFormGroup.get('FAntiguedad').patchValue(
                        editEmployeeData.fantiguedad !== null
                            ? DateHelper.getMomentDate(
                                  editEmployeeData.fantiguedad
                              )
                            : null
                    );
                    this.EmployeeFormGroup.get('FFinContrato').patchValue(
                        editEmployeeData.ffinContrato !== null
                            ? DateHelper.getMomentDate(
                                  editEmployeeData.ffinContrato
                              )
                            : null
                    );
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo1'
                    ).patchValue(editEmployeeData.atributo1);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo2'
                    ).patchValue(editEmployeeData.atributo2);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo3'
                    ).patchValue(editEmployeeData.atributo3);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo4'
                    ).patchValue(editEmployeeData.atributo4);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo5'
                    ).patchValue(editEmployeeData.atributo5);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo6'
                    ).patchValue(editEmployeeData.atributo6);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo7'
                    ).patchValue(editEmployeeData.atributo7);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo8'
                    ).patchValue(editEmployeeData.atributo8);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo9'
                    ).patchValue(editEmployeeData.atributo9);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo10'
                    ).patchValue(editEmployeeData.atributo10);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo11'
                    ).patchValue(editEmployeeData.atributo11);
                    this.EmployeeFormGroup.get(
                        'Attributes.Atributo12'
                    ).patchValue(editEmployeeData.atributo12);

                    if (editEmployeeData.puestoUrgente == 'S') {
                        this.isPuestoUrgente = true;
                    } else {
                        this.isPuestoUrgente = false;
                    }

                    if (editEmployeeData.telCancelado == 'S') {
                        this.isTeleCancelado = true;
                    } else {
                        this.isTeleCancelado = false;
                    }
                }
            });
        this.GetAllProvince();
        this.PostalCodeEventListerner();
        this.GetEmpresaDetails();
    }
    ngAfterContentChecked(): void {
        this.changeDetectionRef.detectChanges();
    }
    ngOnDestroy(): void {
        this.EmployeeDetailSubcription.unsubscribe();
    }

    GetEmpresaDetails() {
        this.empresaTreeViewService.getEmpresa(this.empresaId).subscribe(
            (res) => {
                if (res && res != null) {
                    let result = res.result;
                    this.empresaDetails = result;
                }
            },
            (error) => {
                console.error(error);
            }
        );
    }

    PostalCodeEventListerner(): void {
        this.EmployeeFormGroup.get('PostalCode1')
            .valueChanges.pipe(
                filter((x) => {
                    return x !== null && x.length === 5;
                }),
                tap((_) => {
                    this.Direction1Validating = true;
                    this.Direction1Validated = false;
                }),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((postalCode: string) => {
                    return this.directionService
                        .validateAddressByCp(postalCode)
                        .pipe(
                            map((resp) => {
                                return resp.result;
                            })
                        );
                })
            )
            .subscribe(
                (res) => {
                    if (res === null) {
                        this.Direction1Validating = false;
                    } else {
                        this.EmployeeFormGroup.get('Province1').patchValue(
                            res.province
                        );
                        this.EmployeeFormGroup.get('City1').patchValue(
                            res.city
                        );
                        this.Direction1Validated = true;
                        this.Direction1Validating = false;
                    }
                },
                (err) => {
                    console.error(err);
                }
            );

        this.EmployeeFormGroup.get('PostalCode2')
            .valueChanges.pipe(
                filter((x) => {
                    return x !== null && x.length === 5;
                }),
                tap((_) => {
                    this.Direction2Validating = true;
                    this.Direction2Validated = false;
                }),
                debounceTime(500),
                distinctUntilChanged(),
                switchMap((postalCode: string) => {
                    return this.directionService
                        .validateAddressByCp(postalCode)
                        .pipe(
                            map((resp) => {
                                return resp.result;
                            })
                        );
                })
            )
            .subscribe(
                (res) => {
                    if (res === null) {
                        this.Direction2Validating = false;
                    } else {
                        this.EmployeeFormGroup.get('Province2').patchValue(
                            res.province
                        );
                        this.EmployeeFormGroup.get('City2').patchValue(
                            res.city
                        );
                        this.Direction2Validated = true;
                        this.Direction2Validating = false;
                    }
                },
                (err) => {
                    console.error(err);
                }
            );
    }

    InitEmployeeForm(): void {
        this.EmployeeFormGroup = this._fb.group({
            BirthDate: [null, AdultValidation()],
            Position: [''],
            Telephone1: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Telephone2: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Movil: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Telephone4: [
                '',
                [
                    NineCharacterValidation(),
                    noWhiteSpacesValidator(),
                    Validators.pattern('[0-9]*'),
                ],
            ],
            Direction1: [''],
            Province1: [''],
            City1: [''],
            PostalCode1: [
                '',
                [PostalCodeValidation(), Validators.pattern('[0-9]*')],
            ],
            Direction2: [''],
            Province2: [''],
            City2: [''],
            PostalCode2: [
                '',
                [PostalCodeValidation(), Validators.pattern('[0-9]*')],
            ],
            ObsDireccion: [''],
            Observation: [''],
            Nif: [''],
            Sexo: [''],
            Apellidos: ['', Validators.required],
            Nombre: ['', Validators.required],
            FAntiguedad: [''],
            FFinContrato: [''],
            RefTrabajador: [''],
            TipoConsentimiento: [''],
            Consentimiento: [''],
            PuestoUrgente: [],
            TelCancelado: [],
            Attributes: this._fb.group({
                Atributo1: [''],
                Atributo2: [''],
                Atributo3: [''],
                Atributo4: [''],
                Atributo5: [''],
                Atributo6: [''],
                Atributo7: [''],
                Atributo8: [''],
                Atributo9: [''],
                Atributo10: [''],
                Atributo11: [''],
                Atributo12: [''],
            }),
        });
    }

    GetAllProvince(): void {
        this.directionService.getAllProvince().subscribe(
            (_) => {},
            (err) => {
                console.error(err);
            }
        );
    }

    GetHardCodedList(): void {
        this.ProvinceList = [
            { value: 'ALAVA', viewValue: 'ALAVA' },
            { value: 'ALBACETE', viewValue: 'ALBACETE' },
            { value: 'ALICANTE', viewValue: 'ALICANTE' },
            { value: 'ALMERIA', viewValue: 'ALMERIA' },
            { value: 'ANDORRA', viewValue: 'ANDORRA' },
            { value: 'ASTURIAS', viewValue: 'ASTURIAS' },
            { value: 'AVILA', viewValue: 'AVILA' },
            { value: 'BADAJOZ', viewValue: 'BADAJOZ' },
            { value: 'BALEARES', viewValue: 'BALEARES' },
            { value: 'BARCELONA', viewValue: 'BARCELONA' },
            { value: 'BURGOS', viewValue: 'BURGOS' },
            { value: 'CACERES', viewValue: 'CACERES' },
            { value: 'CADIZ', viewValue: 'CADIZ' },
            { value: 'CANTABRIA', viewValue: 'CANTABRIA' },
            { value: 'CASTELLON', viewValue: 'CASTELLON' },
            { value: 'CEUTA', viewValue: 'CEUTA' },
            { value: 'CIUDAD REAL', viewValue: 'CIUDAD REAL' },
            { value: 'CORDOBA', viewValue: 'CORDOBA' },
            { value: 'CUENCA', viewValue: 'CUENCA' },
            { value: 'GIRONA', viewValue: 'GIRONA' },
            { value: 'GRANADA', viewValue: 'GRANADA' },
            { value: 'GUADALAJARA', viewValue: 'GUADALAJARA' },
            { value: 'GUIPUZCOA', viewValue: 'GUIPUZCOA' },
            { value: 'HUELVA', viewValue: 'HUELVA' },
            { value: 'HUESCA', viewValue: 'HUESCA' },
            { value: 'JAEN', viewValue: 'JAEN' },
            { value: 'LA CORUÑA', viewValue: 'LA CORUÑA' },
            { value: 'LAS RIOJA', viewValue: 'LAS RIOJA' },
            { value: 'LAS PALMAS', viewValue: 'LAS PALMAS' },
            { value: 'LEON', viewValue: 'LEON' },
            { value: 'LLEIDA', viewValue: 'LLEIDA' },
            { value: 'LUGO', viewValue: 'LUGO' },
            { value: 'MADRID', viewValue: 'MADRID' },
            { value: 'MALAGA', viewValue: 'MALAGA' },
            { value: 'MELILLA', viewValue: 'MELILLA' },
            { value: 'MURCIA', viewValue: 'MURCIA' },
            { value: 'NAVARRA', viewValue: 'NAVARRA' },
            { value: 'ORENSE', viewValue: 'ORENSE' },
            { value: 'PALENCIA', viewValue: 'PALENCIA' },
            { value: 'PONTEVEDRA', viewValue: 'PONTEVEDRA' },
            { value: 'SALAMANCA', viewValue: 'SALAMANCA' },
            {
                value: 'SANTA CRUZ DE TENERIFE',
                viewValue: 'SANTA CRUZ DE TENERIFE',
            },
            { value: 'SEGOVIA', viewValue: 'SEGOVIA' },
            { value: 'SEVILLA', viewValue: 'SEVILLA' },
            { value: 'SORIA', viewValue: 'SORIA' },
            { value: 'TARRAGONA', viewValue: 'TARRAGONA' },
            { value: 'TERUEL', viewValue: 'TERUEL' },
            { value: 'TOLEDO', viewValue: 'TOLEDO' },
            { value: 'VALENCIA', viewValue: 'VALENCIA' },
            { value: 'VALLADOLID', viewValue: 'VALLADOLID' },
            { value: 'VIZCAYA', viewValue: 'VIZCAYA' },
            { value: 'ZAMORA', viewValue: 'ZAMORA' },
            { value: 'ZARAGOZA', viewValue: 'ZARAGOZA' },
        ];
    }

    GetProvinceCities(province: string): void {
        this.directionService.getProvinceCities(province).subscribe(
            (_) => {},
            (err) => {
                console.error(err);
            }
        );
    }
    PuestoChangeEvent(value) {
        if (value == true) {
            this.EmployeeFormGroup.patchValue({
                PuestoUrgente: 'S',
            });
        } else {
            this.EmployeeFormGroup.patchValue({
                PuestoUrgente: 'N',
            });
        }
    }

    TeleCanceladoChangeEvent(value) {
        if (value == true) {
            this.EmployeeFormGroup.patchValue({
                TelCancelado: 'S',
            });
            this.isTeleCancelado=true;
        } else {
            this.EmployeeFormGroup.patchValue({
                TelCancelado: 'N',
            });
            this.isTeleCancelado=false;
        }
    }

    GetProvince2Cities(province: string): void {
        this.directionService.getProvince2Cities(province).subscribe(
            (_) => {},
            (err) => {
                console.error(err);
            }
        );
    }

    public Cancel(): void {
        this.dialogRef.close();
        this.EmployeeFormGroup.reset();
    }

    telCanceladoValidation()
    {
        if(this.EmployeeFormGroup.get('TelCancelado').value=='S')
        {
            this.EmployeeFormGroup.patchValue({
                Telephone1:null,
                Telephone2:null,
                Movil:null,
                Telephone4:null,
            });     
        }
    }

    UpdateEmplooyeeData(): void {
        if (this.EmployeeFormGroup.valid) {
            this.telCanceladoValidation();
            this.isSaving = true;
            const employee = this.EmployeeFormGroup.value;
            employee.BirthDate =
                employee.BirthDate !== null
                    ? DateHelper.getUTCDateString(
                          DateHelper.getNativeDate(
                              this.EmployeeFormGroup.value.BirthDate
                          )
                      )
                    : null;
            employee.FAntiguedad =
                employee.FAntiguedad !== null
                    ? DateHelper.getUTCDateString(
                          DateHelper.getNativeDate(
                              this.EmployeeFormGroup.value.FAntiguedad
                          )
                      )
                    : null;
            employee.FFinContrato =
                employee.FFinContrato !== null
                    ? DateHelper.getUTCDateString(
                          DateHelper.getNativeDate(
                              this.EmployeeFormGroup.value.FFinContrato
                          )
                      )
                    : null;

            employee.Direction1 = employee.Direction1
                ? employee.Direction1.toUpperCase()
                : employee.Direction1;
            employee.Direction2 = employee.Direction2
                ? employee.Direction2.toUpperCase()
                : employee.Direction2;
            employee.Apellidos = employee.Apellidos
                ? employee.Apellidos.toUpperCase()
                : employee.Apellidos;
            employee.Nombre = employee.Nombre
                ? employee.Nombre.toUpperCase()
                : employee.Nombre;
            this.employeeService
                .updateEmplooye(
                    this.SelectedTrabajadorId.toString(),
                    employee,
                    this.EmployeeFormGroup
                )
                .subscribe(
                    (res) => {
                        if (res.code === 0) {
                            this.sharedService.ShowSnackBar(
                                'Empleado actualizado con éxito',
                                '',
                                2500
                            );
                            this.employeeService.saveemplooye.emit(res);
                            this.employeeService.getTrabajador(
                                this.SelectedTrabajadorId
                            );
                            this.isSaving = false;
                            this.Cancel();
                        } else {
                            this.sharedService.ShowSnackBar(
                                'Ocurrió un error',
                                'Okay',
                                2500
                            );
                        }
                    },
                    (err) => {
                        console.error(err);
                    }
                );
        }
    }
}
